import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

interface Props {
  isEdit?: boolean;
  link?: string;
  name?: string;
  onClick: (bookmark: PostBookmarkParams) => void;
  type: string;
}

const BookmarkCreateModal = (props: Props) => {
  const color = useColor();
  const { closeModal } = useModalContext();
  const [link, setLink] = useState(props.link || '');
  const [name, setName] = useState(props.name || '');

  useEffect(() => {
    if (props.link) setLink(props.link);
  }, [props.link]);

  useEffect(() => {
    if (props.name) setName(props.name);
  }, [props.name]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLink(e.currentTarget.value);
  };

  const onClick = () => {
    props.onClick({ link, name });
    closeModal();
  };

  return (
    <Wrapper>
      <div className="inner-wrapper">
        <Flex j="space-between" a="center">
          <span className="title">
            {props.isEdit ? 'Edit link' : `Add a link on this ${props.type}`}
          </span>
        </Flex>
        <Space h="16px" />
        <VFlex g={4}>
          <Typo type="body3" weight="m" color={color.gray600}>
            Link
          </Typo>
          <Input
            initFocus
            sizeType="m"
            placeholder="https://www.syncly.app"
            value={link}
            onChange={onChange}
          />
        </VFlex>
        <Space h="16px" />
        <VFlex g={4}>
          <Typo type="body3" weight="m" color={color.gray600}>
            Name
          </Typo>
          <Input
            sizeType="m"
            placeholder="Bookmark name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </VFlex>
        <Space h="32px" />
        <Flex j="flex-end" g="8px">
          <Button variant="outlined" sizeType="m" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" sizeType="m" onClick={onClick}>
            {props.isEdit ? 'Save' : 'Add'}
          </Button>
        </Flex>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;

  .inner-wrapper {
    padding: 24px;
    background: ${(props) => props.theme.colors.gray100};
    border: 1px solid ${(props) => props.theme.colors.gray400};
    border-radius: 8px;
    width: 400px;
  }

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.gray700};
  }
`;

export default BookmarkCreateModal;
